/* unplugin-vue-components disabled */import { render } from "./LogicalTransformer2DImg.vue?vue&type=template&id=740d4c2e&scoped=true"
import script from "./LogicalTransformer2DImg.vue?vue&type=script&lang=js"
export * from "./LogicalTransformer2DImg.vue?vue&type=script&lang=js"

import "./LogicalTransformer2DImg.vue?vue&type=style&index=0&id=740d4c2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740d4c2e"]])

export default __exports__